import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
// testimonial tag animation
const boxes = gsap.utils.toArray('.testimonial-client-story-video-block .testimonial-tag');
boxes.forEach((box, i) => {
    gsap.registerPlugin(ScrollTrigger);
    const anim = gsap.fromTo(box, { autoAlpha: 0, y: 50 }, { duration: 1, autoAlpha: 1, y: 0 });
    ScrollTrigger.create({
        trigger: box,
        animation: anim,
        toggleActions: 'play none none none',
        once: false,
    });
});
// Client story bottom line animation
const bottom = gsap.utils.toArray('.testimonial-client-story-video-block .video-bottom');
bottom.forEach((box, i) => {
    gsap.registerPlugin(ScrollTrigger);
    const anim = gsap.fromTo(box, { autoAlpha: 0, y: 50 }, { duration: 1, autoAlpha: 1, y: 0 });
    ScrollTrigger.create({
        trigger: box,
        animation: anim,
        toggleActions: 'play none none none',
        once: false,
    });
});
const boxWrapper = gsap.utils.toArray('.testimonial-client-story-video-block .box-wrapper');
boxWrapper.forEach((box, i) => {
    gsap.registerPlugin(ScrollTrigger);
    const anim = gsap.from(box, { duration: 1, opacity: 0, x: -300 });
    ScrollTrigger.create({
        trigger: box,
        animation: anim,
        toggleActions: 'play none none none',
        once: false,
    });
});
// // animate ".box" from x position of 300 to the current value of 100
// gsap.from(".box-wrapper", {
//     opacity: 0, 
//     x: -300, 
//     duration: 1
//   });
//testimonial text animation
